<div class="remove_scroll">
    <router-outlet></router-outlet>
</div>
